export default __webpack_public_path__ + "static/media/avatar.d8a33b14.png";